var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',{attrs:{"title":"סיכום חודשי","loading":_vm.loading,"error":_vm.error,"chart":_vm.chart}})}
var staticRenderFns = []

export { render, staticRenderFns }